// SOL Kids site config
export const SITE = {
  brand: "SOL Kids",
  tagline: "Made for little adventures.",
  whatsappNumber: "919830804015", // +91 98308 04015
  email: "hello@solkids.in",
  instagram: "@solkids_eyewear",
  instagramUrl: "https://instagram.com/solkids_eyewear",
};

export const whatsappLink = (message) => {
  const text = encodeURIComponent(message || `Hi SOL Kids! I'd love to know more about your sunglasses.`);
  return `https://wa.me/${SITE.whatsappNumber}?text=${text}`;
};

// Master swatch color tokens
// (Mapping of named colourways used across collections — used for visual swatch dots)
export const COLOR_HEX = {
  vanilla: "#F4ECDA",
  peach: "#F2B79F",
  tangerine: "#F39C5B",
  minty: "#B8E0CF",
  grape: "#7E5B8B",
  sunshine: "#F2D06B",
  blueberry: "#3D5C99",
  bubbles: "#BBD8E8",
  ninja: "#1A1A1A",
  "cherry cola": "#5B1E1A",
  "black currant": "#2A1A33",
  sky: "#A9CDE5",
  indigo: "#3E4E8F",
  "indigo dark": "#1F2A55",
  "diet coke": "#4A2F2A",
  ketchup: "#C7372C",
  turtle: "#3F6F4A",
  "candy floss": "#F2C8D9",
  lily: "#F9F4E9",
  goose: "#A5A8A7",
  violet: "#8B6FAE",
  citrus: "#D9D14A",
  sage: "#B8C5B1",
  "bubble gum": "#F0A8C3",
  blossom: "#F4B5B6",
  snorlax: "#1E3147",
  "ice lolly": "#D4ECF4",
  oreo: "#262626",
  rose: "#E29AA0",
  cherry: "#B23332",
  fanta: "#F0793D",
  raspberry: "#C24B6B",
  spongebob: "#F2C84B",
  splash: "#7AB7D4",
  "honey bee": "#E8B83F",
  "orange juice": "#F0843C",
  kiwi: "#B5C24F",
  lemonade: "#F7E47E",
  "indigo dark": "#1F2A55",
  "diet coke": "#4A2F2A",
};

export const colorOf = (name) => COLOR_HEX[name?.toLowerCase()] || "#CFCFCB";

export const PERSONALITIES = [
  { slug: "sunshine-chasers", title: "Sunshine Chasers", emoji: "🌞", line: "Face up. Squinting less. Playing more.", color: "var(--sun)", collections: ["sol"] },
  { slug: "non-stop-runners", title: "Non-Stop Runners", emoji: "🏃", line: "Shades on, already three steps ahead.", color: "var(--coral)", collections: ["rio", "vamos"] },
  { slug: "tiny-trendsetters", title: "Tiny Trendsetters", emoji: "🎨", line: "Picks the sunglasses first. Game follows.", color: "var(--lavender)", collections: ["chica", "lolo", "rosa"] },
  { slug: "dreamy-wanderers", title: "Dreamy Wanderers", emoji: "☁️", line: "Watching the sky through tinted lenses.", color: "var(--sky)", collections: ["luna", "nube"] },
  { slug: "fearless-tryers", title: "Fearless Tryers", emoji: "🚀", line: "Figures it out mid-air.", color: "#E8B83F", collections: ["tico", "kiko"] },
  { slug: "high-energy-kids", title: "High Energy Kids", emoji: "🤸", line: "Jump. Run. Spin. Still on.", color: "var(--coral)", collections: ["viva", "rumba"] },
  { slug: "friendly-explorers", title: "Friendly Explorers", emoji: "😊", line: "Waves at everyone from behind cool shades.", color: "var(--sage)", collections: ["hola", "bono", "pico"] },
];

export const FEATURES = [
  { key: "polarized", title: "Polarized Lenses", line: "Cuts the glare. Sharpens the world." },
  { key: "uv", title: "100% UV Protection", line: "Tested for tiny eyes." },
  { key: "lightweight", title: "Ultra Lightweight", line: "Light enough to forget they're on." },
  { key: "flexible", title: "Flexible Frames", line: "Bend, twist, snap back. Like kids." },
  { key: "safe", title: "Kid Safe Materials", line: "No nasties. Built for skin, not stickers." },
  { key: "play", title: "Built For Play", line: "Survives playgrounds, sandboxes, slides." },
];

export const FAQS = [
  { q: "What ages are SOL Kids sunglasses for?", a: "Our frames are designed for kids aged roughly 2 to 10, with several sizes across our collections. Each product page lists the recommended fit." },
  { q: "Are the lenses really polarized?", a: "Yes — every pair has true polarized lenses with 100% UV protection. Real protection, no shortcuts." },
  { q: "Will they survive my child?", a: "We hope so. Frames are flexible, lightweight and built for play — they bend, twist, and bounce back from real childhoods." },
  { q: "How do I clean them?", a: "A soft microfiber cloth (included) and a gentle wipe is all you need. Skip paper tissues — they scratch." },
  { q: "How do I pick the right size?", a: "Each collection lists frame width, bridge and arm length in cm. If unsure, WhatsApp us — we'll help you choose." },
  { q: "Shipping and returns?", a: "We ship pan-India in 3–5 working days. Shipping charges extra, as applicable, and are calculated at checkout. 7-day no-fuss exchange on unworn frames. Just WhatsApp us." },
  { q: "Do you offer warranty?", a: "Yes — 6 months on frames against manufacturing defects. Sand, drops and the playground are not covered (sorry)." },
];
